export default __webpack_public_path__ + "static/logo-b3268c389adbd7ea450d7491ee1833f5.png";